import { filter } from 'lodash'
import XRegExp from 'xregexp'

export const muteWordHits = (status, muteWords) => {
  const statusText = status.text.toLowerCase()
  const statusSummary = status.summary.toLowerCase()
  const hits = filter(muteWords, (muteWord) => {
    return statusText.includes(muteWord.toLowerCase()) || statusSummary.includes(muteWord.toLowerCase())
  })

  return hits
}

export const muteWordHitsWhole = (status, muteWords) => {
  const statusText = status.text.toLowerCase()
  const statusSummary = status.summary.toLowerCase()
  const hits = filter(muteWords, (muteWord) => {
    var re = XRegExp("(\\p{Z}|\\p{P}|^)" + muteWord.toLowerCase() + "(\\p{Z}|\\p{P}|$)", "gui")
    return re.test(statusText) || re.test(statusSummary)
  })

  return hits
}
